var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(" Tissue Status ")]),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.getDaskboard,"fixed-header":"","height":"300"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }